import { OperationVariables, gql } from "@apollo/client";


import GraphQL from "../../graphQL";

const query = gql`
mutation updateWantedCompetenceState($id:Int!) {
    updateWantedCompetenceState(id: $id)
},
`;

/**
 * Marks the first experience as read.
 * 
 * @returns {Promise<boolean>}
 */
export default async function updateWantedCompetenceState(id: number)
{
    const variables: OperationVariables = {
        id,
    };
    return GraphQL.mutate<boolean>(query, variables);
}